module.exports = __webpack_public_path__ + "img/experience.48e8ca89.svg";